<template>
  <div id="app">
    <header>
      <nav id="app-header">
        <ul class="left">
          <router-link to="/">
            <li><img src="./assets/images/logo.png"/></li>
            <li><a>未谷科技</a></li>
          </router-link>
        </ul>
        <ul class="right">
          <li class="rightLi"><router-link to="/About" class="rightA">关于我们</router-link></li>
          <li class="rightLi">
            <a id="serviceA" class="rightA" style="cursor:default;">产品服务</a>
            <div class="dropdown-content">
              <router-link to="/ProductAndService/HMOC">儿童健康管理</router-link>
              <router-link to="/ProductAndService/Phbo">量表评估系统</router-link>
              <router-link to="/ProductAndService/DataService">数 据 服 务</router-link>
              <router-link style="margin-bottom: 9px" to="/ProductAndService/MOBEC">仪器购买租赁</router-link>
            </div>
          </li>
          <li class="rightLi">
            <a id="solutionA" class="rightA" style="cursor:default;">解决方案</a>
            <div class="dropdown-content">
              <router-link to="/Solution/Case">流行病学调研</router-link>
              <router-link to="/Solution/HugeData">大数据计算</router-link>
              <router-link to="/Solution/LCStudies">大型队列人群</router-link>
              <router-link style="margin-bottom: 9px" to="/Solution/CHMAS">儿童健康管理</router-link>
            </div>
          </li>
          <li class="rightLi"><router-link to="/" class="rightA">首页</router-link></li>
        </ul>
      </nav>
    </header>
    <li class="head-line"></li>
    <router-view></router-view>
    <footer id="app-footer">
      <div class="foot-main">
        <div class="footer-logo">
          <img src="./assets/images/logo.png"/>
          <h1>未谷科技</h1>
        </div>
        <h2></h2>
        <div class="Propaganda">
          <h1>关注儿童早期发展</h1>
          <h1>激发儿童最大潜能</h1>
        </div>
        <div class="contact">
          <div>
            <img src="./assets/images/phone.png" style="width: 16px;height: 16px;"/>
            <a>021-64198525</a>
          </div>
          <div class="mail">
            <img src="./assets/images/mail.png" style="width: 16px;height: 12px;padding-top:4px;"/>
            <a href="mailto:service@teamemo.com">service@weiguyun.com</a>
          </div>
          <div>
            <img src="./assets/images/gps.png" style="width: 14px;height: 18px;"/>
            <a>上海市剑川路951号2号楼208室</a>
          </div>
        </div>
        <div class="WechatQRCode">
          <h1>官方微信公众号</h1>
          <img src="./assets/images/WechatQRCode.png"/>
        </div>
      </div>
      <h1 class="copyRight">Weigu Information Technology Co.,Ltd.&emsp;<a href="https://beian.miit.gov.cn/" target="_blank">沪ICP备15026705号-1 © 2015-2018</a></h1>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'app',
  data(){
    return{
      active: false
    }
  }
}

</script>

<style lang="scss">
html,body,ul,li,a,p,nav,header,h1,h2,div,figure{padding:0px; margin:0px;}
ul,li{list-style:none;}
body{font-family:"微软雅黑","Microsoft YaHei","PingFang SC";}
//body{font-family:"PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑","Helvetica Neue",Helvetica,Arial;}
.dropdown-content{
  display: none;
  position: absolute;
  z-index: 999;
  background-image: url(./assets/images/menu_bg.png);
  margin-left: -16px;
  width: 102px;
  padding-top: 12px;
  background-size:100% 100%;
  -moz-background-size:100% 100%;
  //box-shadow: 0px 8px 0px rgba(0,0,0,0.2);
}

.dropdown-content a {
    color: #323232;
    display: block;
    padding-left: 9px;
    padding-right: 9px;
    margin-left: 6px;
    margin-right: 6px;
    text-align: justify;
    text-align-last: justify;
    -moz-text-align-last:justify;
    text-justify:inter-ideograph;
    padding-top: 10px;
    padding-bottom: 10px;
    font-size: 12px;
    height: 14px;
    text-decoration: none;
}
.dropdown-content a:after {
    content: " ";
    display: inline-block;
    overflow: hidden;
    height: 0;
    width: 100%;
}
.dropdown-content a:hover{
  background-color: rgba(255,255,255,0.6);
  filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=#99ffffff,endColorstr=#99ffffff);
}
#app-header .right li:hover .dropdown-content {
    display: block;
}

#app{
  text-align:center;
  width: 100%;
  min-width: 1080px;
}
#app header{
  height: 100px;
}
#app .head-line{
  background-color: #f0f0f0;
  width: 100%;
  height: 1px;
}
#app-header{
  display:inline-block;
  width: 1080px;
}
#app-header ul{
  display: inline;
}
#app-header .left{
	height:100px;
}
#app-header .left li{
  float: left;
	height:100px;
  line-height: 100px;
  display: inline;
}
#app-header .left li img{
  margin-top: 25px;
  margin-left: 20px;
  height: 58px;
  width: 48px;
}
#app-header .left li a{
  color:#282828;
  margin-left: 16px;
  font-size: 28px;
  text-decoration: none;
}
#app-header .right{
	height:100px;
}
#app-header .right .rightLi{
	float:right;
  display: inline-block;
  margin-top: 38px;
  position: relative;
}

#app-header .right .rightLi .rightA{
  color:#282828;
  text-decoration: none;
  margin-right: 20px;
  cursor:pointer;
  font-size: 18px;

}
#app-header .right .rightLi .rightA:hover{
color: #74B6EC;
}
#app-header .right .rightLi .router-link-exact-active{
  color:#74B6EC;
  font-weight: bold;
}
#app-header .right .rightLi .dropdown-content .router-link-exact-active{
  color:#000;
  background-color: rgba(255,255,255,0.4);
  filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=#66ffffff,endColorstr=#66ffffff);
  font-weight:normal;
}

#app footer img{
  width: 100%;
  display: block;
}
#app-footer{
  background-color: #354656;
}
#app-footer .foot-main{
  display: inline-flex;
  height: 200px;
  width: 1080px;
  //justify-content:center;
  align-items:center;
}
#app-footer .copyRight{
  height: 55px;
  line-height: 55px;
  color: #909090;
  font-weight: normal;
  font-size: 14px;
  background-color: #fff;
}
#app-footer .foot-main .footer-logo{
  height: 70px;
  margin-right: 10px;
  margin-left: 20px;
}
#app-footer .foot-main .footer-logo img{
  height: 58px;
  width: 48px;
}
#app-footer .foot-main .footer-logo h1{
  font-size: 12px;
  width: 4em;
  font-weight: normal;
  margin-top: 8px;
  color: #cacbcd;
  padding: 0px;
}
#app-footer .foot-main h2{
  width: 2px;
  height: 64px;
  background-color: #f0f0f0;
}
#app-footer .foot-main .Propaganda h1{
  font-size: 16px;
  width: 128px;
  font-weight: normal;
  color: #fff;
  margin-left: 24px;
  margin-bottom: 6px;
}
#app-footer .foot-main .contact{
  width: 375px;
  text-align:left;
  margin-left: 244px;
  margin-right: 70px;
}
#app-footer .foot-main .contact div{
  height: 16px;
  margin-top: 13px;
  margin-bottom: 13px;
}
#app-footer .foot-main .contact img{
  vertical-align:text-top;
  display: inline;
}
#app-footer .foot-main .contact a{
  color: #fff;
  font-size: 12px;
  vertical-align: top;
  margin-left: 8px;
  display: inline;
  text-decoration: none;
}
#app-footer .foot-main .contact .mail a:hover{
  text-decoration:underline;
}
#app-footer .foot-main .WechatQRCode{
  margin-right: 20px;
}
#app-footer .foot-main .WechatQRCode h1{
    font-size: 16px;
    color: #fff;
    margin-bottom: 8px;
}
#app-footer .foot-main .WechatQRCode img{
  width: 139px;
  height: 139px;
}

</style>



// WEBPACK FOOTER //
// src/App.vue